import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, MoreVertical, Info, HelpCircle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

import LogoImage from "../images/info payanagdi title.png"; 

export default function TopNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // ഈ പേജുകളിൽ ബാക്ക് ബട്ടൺ കാണിക്കില്ല (Main Tabs)
  const mainTabs = ["/", "/donors", "/profile"]; 
  const isMainTab = mainTabs.includes(location.pathname);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <>
      {/* 🌟 TOP NAVBAR (Premium Glassmorphism) 🌟 */}
      <div className="sticky top-0 z-[100] bg-white/80 backdrop-blur-xl border-b border-gray-200/50 shadow-sm px-4 py-2.5 flex items-center justify-between transition-all duration-300">
        
        {/* Left Section: Back Button */}
        <div className="w-12 flex items-center justify-start relative">
          <AnimatePresence mode="popLayout">
            {!isMainTab && (
              <motion.button
                initial={{ opacity: 0, x: -10, scale: 0.8 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: -10, scale: 0.8 }}
                transition={{ type: "spring", stiffness: 300, damping: 25 }}
                onClick={handleBack}
                className="p-2 -ml-2 rounded-full hover:bg-gray-100 text-gray-600 transition-colors duration-300"
                aria-label="Go back"
              >
                <ArrowLeft size={22} strokeWidth={2.5} />
              </motion.button>
            )}
          </AnimatePresence>
        </div>

        {/* Center Section: Logo */}
        <div 
          className="flex-1 flex justify-center cursor-pointer items-center transition-transform active:scale-95"
          onClick={() => navigate("/")}
        >
          <img 
            src={LogoImage} 
            alt="Info Payangadi Logo" 
            className="h-6 sm:h-7 object-contain drop-shadow-sm pointer-events-none" 
          />
        </div>

        {/* Right Section: Dropdown Menu */}
        <div className="w-12 flex items-center justify-end relative">
          <motion.button
            whileTap={{ scale: 0.9 }}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`p-2 -mr-2 rounded-full transition-colors duration-300 ${isMenuOpen ? "bg-blue-50 text-blue-600" : "text-gray-600 hover:bg-gray-100"}`}
            aria-label="Menu"
          >
            <MoreVertical size={22} strokeWidth={2.5} />
          </motion.button>

          {/* 🌟 Animated Dropdown Menu 🌟 */}
          <AnimatePresence>
            {isMenuOpen && (
              <motion.div 
                initial={{ opacity: 0, scale: 0.95, y: -10, transformOrigin: "top right" }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95, y: -10 }}
                transition={{ duration: 0.15, ease: "easeOut" }}
                className="absolute right-0 top-12 w-52 bg-white/95 backdrop-blur-3xl rounded-[1.5rem] shadow-[0_15px_40px_-10px_rgba(0,0,0,0.15)] border border-gray-100/80 py-2 overflow-hidden z-50"
              >
                <div className="px-2 py-1">
                  <button 
                    onClick={() => { setIsMenuOpen(false); navigate("/about"); }}
                    className="w-full px-3 py-2.5 flex items-center gap-3 text-left hover:bg-blue-50 hover:text-blue-600 rounded-xl transition-all duration-200 text-gray-700 group"
                  >
                    <div className="bg-gray-50 group-hover:bg-blue-100/50 p-1.5 rounded-lg transition-colors">
                      <Info size={16} strokeWidth={2.5} />
                    </div>
                    <span className="font-bold text-sm">About Us</span>
                  </button>

                  <button 
                    onClick={() => { setIsMenuOpen(false); navigate("/help"); }}
                    className="w-full px-3 py-2.5 flex items-center gap-3 text-left hover:bg-blue-50 hover:text-blue-600 rounded-xl transition-all duration-200 text-gray-700 group mt-1"
                  >
                    <div className="bg-gray-50 group-hover:bg-blue-100/50 p-1.5 rounded-lg transition-colors">
                      <HelpCircle size={16} strokeWidth={2.5} />
                    </div>
                    <span className="font-bold text-sm">Help & Contact</span>
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

      </div>

      {/* 🌫️ Overlay for closing menu 🌫️ */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[90] bg-slate-900/5" 
            onClick={() => setIsMenuOpen(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
}